<template>
	<div class="blain-logistics">
		<div class="header">
			<h1>
				<span class="logo"></span>
				<span class="text">Shipments in Transit</span>
			</h1>
		</div>
		<div class="main-wrapper">
			<div class="top-wrapper">
				<div class="us-map" id="usmap">
				</div>

				<div class="checkout-sessions">
					<h2>[TODO]</h2>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Bugsnag from '@bugsnag/js'

	let refreshInterval = null;
	let myMap = null;
	let mapContainer = null;
	import 'jvectormap-next';
	import './us-aea-map';
	import '../../less/jvectormap.css';

	export default {
		name: 'BlainLogistics',

		data() {
			return {
				shipmentsInTransit: {},
				serverTime: null
			};
		},

		mounted() {
			console.log("Blain logistics module initiated");
			mapContainer = window.$('#usmap');
			mapContainer.vectorMap({
				map: 'us_aea',
				backgroundColor: '#000',
				zoomOnScroll: false,
				panOnDrag: false,
				regionsSelectable: false,
				markersSelectable: false,
				regionStyle: {
					initial: {
						fill: '#666'
					}
				},
				markerStyle: {
					initial: {
						stroke: "rgba(255,255,255,0.5)",
						r: 3
					}
				},
				onRegionOver: function (e) {
					e.preventDefault();
				},
				onRegionTipShow: function (e) {
					e.preventDefault();
				},
				onMarkerOver: function (e) {
					e.preventDefault();
				},
				onMarkerTipShow: function (e) {
					e.preventDefault();
				}
			});
			myMap = mapContainer.vectorMap('get', 'mapObject');

			this.refreshData();
			refreshInterval = setInterval(this.refreshData, 60000);
			window.addEventListener('overscan', this.resizeChart);
		},
		
		destroyed() {
			window.removeEventListener('overscan', this.resizeChart);
			console.log("Stopping Blain logistics module");
			clearInterval(refreshInterval);
			mapContainer = null;
		},
		
		methods: {

			refreshData() {
				let self = this;
				this.$http.post('/blain/refresh-logistics', {}).then(response => {
					let d = response.body;

					self.serverTime = new Date(d.serverTime);
					self.updateShipments(d.shipmentsInTransit);
				}).catch(e => {
					Bugsnag.notify(new Error(e.url), function (event) {
						event.addMetadata('httpResponse', e);
					});
					console.error(e);
				});
			},

			updateShipments(shipments) {
				// Iterate through new carts and add new ones
				for (let x = 0, len = shipments.length; x < len; x++) {
					let s = shipments[x];
					s.markerType = this.getMarkerType(s);
					if (!this.shipmentsInTransit.hasOwnProperty(s.trackingNumber)) {
						this.shipmentsInTransit[s.trackingNumber] = s;
						myMap.addMarker(s.trackingNumber, {
							latLng: [ s.latitude, s.longitude ],
							name: s.trackingNumber,
							style: { fill: this.getMarkerFill(s.markerType) }
						});
					}
				}

				// Iterate through old carts and remove old ones
				let keyNames = Object.keys(this.shipmentsInTransit);
				let toRemove = []
				for (let x = 0, len = keyNames.length; x < len; x++) {
					let i = keyNames[x];
					if (!shipments.some(s => s.trackingNumber === i)) {
						if (myMap.markers.hasOwnProperty(i)) toRemove.push(i);
						delete this.shipmentsInTransit[i];
					}
				}

				// Update map markers
				if (toRemove.length > 0) myMap.removeMarkers(toRemove);
			},

			getMarkerType(shipment) {
				let estimatedDelivery = new Date(shipment.estimatedDelivery);
				let originalEstimatedDelivery = new Date(shipment.originalEstimatedDelivery);
				if (originalEstimatedDelivery < estimatedDelivery) return "late";
				if (originalEstimatedDelivery > estimatedDelivery) return "early";
				return "ontime"
			},

			getMarkerFill(markerType) {
				switch (markerType) {
					case "early":
						return "#090";
					case "late":
						return "#c00";
					default:
						return "#3683ff";
				}
			},

			getMarkerFillByCourier(courierID) {
				switch (courierID) {
					case "FEDEX":
						return "#CC0";
					case "ESTES":
						return "#c00";
					default:
						return "#33c";
				}
			}
		}
	}
</script>

<style lang="less">
	@import '../../less/_variables.less';
	@import '../../less/progressbar.less';

	@bg-summary: #333;

	.blain-logistics {
		font-family: @font-main;
		padding: 0;
		height: 100%;
		color: #fff;
		display: flex;
		flex-direction: column;

		.header {
			flex: 0 0 auto;
			width: 100%;
			padding: 2% 2% 1%
		}

		h1 {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			margin: 0;
			font-size: 2.5em;
			line-height: 1em;
			height: 100%;

			span.logo {
				background-image: url(images/blain.svg);
				background-size: contain;
				background-position: center center;
				background-repeat: no-repeat;
				width: 3.5em;
				height: 1.7em;
			}

			span.text {
				text-transform: uppercase;
				padding-left: 0.5em;
			}
		}

		.main-wrapper {
			flex: 0 1 auto;
			display: flex;
			flex-direction: column;
			width: 100%;
		}

		.top-wrapper {
			display: flex;
			justify-content: space-between;
			height: 70%;
			flex: 0 0 70%;
			padding: 0 2% 0.5%;
			width: 100%;
		}

		.us-map {
			width: 53%;
			height: 100%;
		}
	}

	.jvectormap-zoomin,
	.jvectormap-zoomout,
	.jvectormap-tip {
		display: none;
	}

	.jvectormap-marker {
		animation: 1s marker 1;
	}

	.red {
		color: #F66;
	}

	.orange {
		color: #F93;
	}

	.yellow {
		color: #FF0;
	}
	
	@keyframes marker {
		from {
			stroke-width: 20;
			stroke-opacity: 0;
			fill-opacity: 0;
		}
		to {
			stroke-width: 1;
			stroke-opacity: 1;
			fill-opacity: 1;
		}
	}
</style>


// WEBPACK FOOTER //
// blain-logistics.vue?11d9f50f